// extracted by mini-css-extract-plugin
export const app = "App__app__4zh7k";
export const atlasGrotesk = "App__atlasGrotesk__nfm6I";
export const atlasGroteskBold = "App__atlasGroteskBold__eVPny App__atlasGrotesk__nfm6I";
export const atlasGroteskMedium = "App__atlasGroteskMedium__o9W7X App__atlasGrotesk__nfm6I";
export const atlasGroteskRegular = "App__atlasGroteskRegular__NDe9i App__atlasGrotesk__nfm6I";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "App__sans__pt+T2";
export const sansBold = "App__sansBold__geBuk App__sans__pt+T2";
export const sansLight = "App__sansLight__KpCu3 App__sans__pt+T2";
export const sansMedium = "App__sansMedium__ZAU+h App__sans__pt+T2";
export const sansRegular = "App__sansRegular__nyWSH App__sans__pt+T2";
export const sansSemibold = "App__sansSemibold__g6Oh0 App__sans__pt+T2";
export const semibold = "600";
export const serif = "App__serif__sJ+ie";
export const serifLight = "App__serifLight__l1fyU App__serif__sJ+ie";
export const serifMedium = "App__serifMedium__HdyQW App__serif__sJ+ie";
export const serifRegular = "App__serifRegular__Aumyr App__serif__sJ+ie";
export const slidLeft = "App__slidLeft__NN0u3";
export const slideable = "App__slideable__ucVu9";